<script lang="ts">
  import { Page } from '@stickerapp-org/athena/Page';
  import '../app.css';
  import { onMount } from 'svelte';
  import { setCommonTranslationsContext } from '@athena-lib/commonTranslationsContext';
  import { shouldLoadGtm, getGtmJsUrl } from '$lib/gtm/setup';
  import { getKameleoonUrl, kameleoonInit } from '$lib/kameleoon/setup';
  import { checkoutVersionSessionKey, getCheckoutSdk } from '$lib/checkout.svelte';

  const { data, children } = $props();

  let loadedKameleoon = $state(!data.useKameleoon);

  setCommonTranslationsContext(data.commonTranslationsStory);
  onMount(async () => {
    if (data.useKameleoon) {
      // Max time for loading Kameleoon
      setTimeout(() => {
        loadedKameleoon = true;
      }, 500);
      await kameleoonInit(data.kameleoonId);
      loadedKameleoon = true;
    }
  });

  let hasScrolled = false;
  $effect(() => {
    // hash links only work if the element is visible immeadiately
    // which they aren't, since we're waiting for kameleoon to load
    // so this is a fix only for pages that need kameleoon
    const urlHash = window.location.hash;

    if (urlHash && !hasScrolled && loadedKameleoon) {
      const element = document.querySelector(CSS.escape(urlHash));

      if (element) {
        element.scrollIntoView();
        hasScrolled = true;
      }
    }
  });
  const checkoutSdk = $derived(getCheckoutSdk());
  $effect(() => {
    sessionStorage.setItem(checkoutVersionSessionKey, checkoutSdk ? '2' : '1');
  });
</script>

<svelte:head>
  {#if shouldLoadGtm()}
    <link rel="preload" href={getGtmJsUrl()} as="script" />
  {/if}

  {#if data.useKameleoon}
    <link rel="preload" href={getKameleoonUrl(data.kameleoonId)} as="script" />
  {/if}

  <link rel="manifest" href="/webapp-manifest" />
  <link rel="icon" href={data.webappManifest.icons[0].src} />

  <meta name="theme-color" content={data.webappManifest.theme_color} />
  <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />

  <script
    src="https://uptime.betterstack.com/widgets/announcement.js"
    data-id="170704"
    async
    type="text/javascript"
  >
  </script>
</svelte:head>

<Page class={!loadedKameleoon ? 'hidden' : ''}>
  {@render children()}
</Page>
